import { CommonStatusTag } from 'components/CommonStatusTag';
import { colors } from 'constants/colors';

export const TicketStatusTag = ({ isClosed }: { isClosed: boolean }) => {
    if (isClosed) {
        return <CommonStatusTag backgroundColor={colors.green} label="Terminé" labelColor={colors.pureWhite} />;
    }

    return <CommonStatusTag backgroundColor={colors.blue} label="Ouvert" labelColor={colors.pureWhite} />;
};
